export default __webpack_public_path__ + "static/media/banner-images.003854f6.png";